
import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getOrganisationList } from '../../../services/adminApiService/organisationApi/OrganisationApiService';
import { useNavigate } from 'react-router-dom';
import { getAllDataIndividaulList, getIndividaulList } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import { LocationContext } from '../../../context/LocationContext';
import DistrictFilter from '../districtFilter/DistrictFilter';
import CategorySubCategoryFilter from '../categorySubCateogoryFilter/CategorySubCategoryFilter';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import RefreshButton from '../../../jsx/components/RefreshButton/RefreshButton';
import { useFilterReset } from '../../../hooks/useFilterReset';
import SportFilter from '../sportFilter/SportFilter';
import { useSport } from '../../../context/SportContext';
import DownloadExcelButton from '../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton';
import { IndividualExcelHeaders } from './IndividualExcelHeader';
import InsitutionCategoryFilter from '../insitutionCategoryFilter/InsitutionCategoryFilter';
import ImportExcelModal from '../organization/ImportExcelModal';
import {
    deleteNonVerifiedUserData,
    getAdminCategoryType
} from '../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi';
import GenderFilter from '../genderFilter/GenderFilter';
import { useGender } from '../../../context/GenderContext';
import swal from "sweetalert";
import notify from "../../../utils/notification";
import { AuthContext } from "../../../context/AuthContext";
import { isUserSuperAdmin, isUserAdminChecker, isCompletedStatus, isApplicationProcessedForRole } from "../../../utils/userRoleUtils";

const IndividualList = () => {
    const { user, USER_LEVEL } = useContext(AuthContext);
    const isSuperAdmin = isUserSuperAdmin(user);
    const isAdminChecker = isUserAdminChecker(user);
    const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
    const { selectedSubCategoryId, setSelectedSubCategoryId, selectedInsitutionCategoryId, setSelectedInsitutionCategoryId,selectedCategoryId,setSelectedCategoryId } = useCategoryFilter();
     const { selectedGender, setSelectedGender } = useGender();
  

    const [organisationdataList, setOrganisationdataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [adminCategoryTypeData, setAdminCategoryTypeData] = useState([]);
    const [showImportModal, setShowImportModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const getDefaultStatus = () => {
        if (isSuperAdmin) return "pass_by_admin_checker";
        if (isAdminChecker) return "pass_by_dso";
        return "final_submit";
    };
    const [selectedStatus, setSelectedStatus] = useState(getDefaultStatus());
    const navigate = useNavigate();
    const handleVerificationClick = (id) => {
        localStorage.removeItem('remarksIndividual');
        navigate(`/verification-Individual-form/${id}`); // Absolute path
    };
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const [selectedInsitutionCategory, setSelectedInsitutionCategory] = useState('');
    const { selectedSportId, setSelectedSportId } = useSport();
    const [orgselectedCategory, setOrgSelectedCategory] = useState('');

    const individualDataList = organisationdataList?.data || organisationdataList || [];
    const firstPendingIndex = Array.isArray(individualDataList)
        ? individualDataList.findIndex((item) => !isApplicationProcessedForRole(item?.status, user))
        : -1;
    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
        setCurrentPage(1);
    };
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const getOrganisationListApi = async (perPage, currentPage, statusParam, searchValue, selectedDistrictId, selectedSubCategoryId, selectedCategoryId ,selectedSportId, selectedInsitutionCategoryId, orgselectedCategory,selectedGender) => {
        setLoading(true);
        try {
            const effectiveStatus = isSuperAdmin
                ? "pass_by_admin_checker"
                : isAdminChecker
                ? "pass_by_dso"
                : (statusParam !== undefined && statusParam !== null ? statusParam : selectedStatus);

            const response = await getIndividaulList(perPage, currentPage, effectiveStatus, searchValue, selectedDistrictId, selectedSubCategoryId, selectedCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory,selectedGender);
            setOrganisationdataList(response?.data?.data);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };

      const getAdminCategoryTypeListApi = async () => {
        try {
          const response = await getAdminCategoryType(1);
          // console.log("responseCategoryTYpe", response);
          setAdminCategoryTypeData(response?.data);
        } catch (error) {
          console.error("Login error:", error);
        }
      };
       useEffect(() => {
          getAdminCategoryTypeListApi();
        }, []);
    useEffect(() => {
        getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory,selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory,selectedGender);
    }, [currentPage, perPage, selectedStatus, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory,selectedGender]);

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };
    const handleDeleteClick = async (id) => {
        const isConfirm = await swal({
            title: "Are you sure you want to delete this user profile?",
            text: "This action cannot be undone, and all associated data will be permanently removed.",
            icon: "warning",
            buttons: ["Cancel", "Yes, Delete"],
            dangerMode: true,
        });

        if (!isConfirm) return; // ❌ Stop if user cancels

        try {
            const payload = { id };

            const response = await deleteNonVerifiedUserData(payload);

            if (response?.data?.status === true) {
                swal("Deleted Successfully", response?.data?.message, "success");
                getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory,selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory,selectedGender);
            } else {
                notify("error", response?.data?.message);
            }
        } catch (error) {
            console.log("error", error);
            notify("error", "Something went wrong. Please try again.");
        }
    };

    const handleRefresh = useFilterReset({
        setSearchValue,
        setDebouncedSearchValue,
        setSelectedStatus,
        setSelectedDistrictId,
        setSelectedSubCategoryId,
        setSelectedCategoryId,
        setSelectedInsitutionCategoryId,
        selectedInsitutionCategory,
        setSelectedInsitutionCategory,
        // setCurrentPage,
        setSelectedCategory,
        setOrgSelectedCategory,
        setSelectedSubCategory,
        setSelectedSportId,
        setPerPage,
        setCurrentPage,
        fetchFunction: getOrganisationListApi,
         setSelectedGender,

    });

    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        setSelectedStatus(getDefaultStatus());
        setDebouncedSearchValue("");
        setSelectedDistrictId("");
        setSelectedSubCategoryId("");
        setSelectedCategoryId("");
        setSelectedInsitutionCategory("");
        setSelectedInsitutionCategoryId("");
        setSelectedSportId("");
        setSelectedGender(0);
    }, [isSuperAdmin, isAdminChecker]);
    return (
        <>
            <PageTitle
                activeMenu="Individual List"
                motherMenu="Manage Registration"
            />
            <div className="col-12">
                <div className="card">
                    <div className="">
                        <div className="d-flex justify-content-between  mt-3 w-100 px-4 mb-3">
                            <div className="d-flex">
                                <div>
                                    <FilterNumber value={perPage} onChange={setPerPage} />
                                </div>
                                <div>
                                    <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} />
                                </div>
                            </div>


                            <div className="d-flex">
                                <div className="mx-2">
                                    <DownloadExcelButton
                                        data={
                                            (organisationdataList?.data || organisationdataList || []).map((item, index) => ({
                                                serial: index + 1, // ✅ add serial number
                                                ...item,
                                            }))
                                        }
                                        //  data={organisationdataList}
                                        // headers={IndividualExcelHeaders}
                                        headers={[
                                            { label: "Sr.No", key: "serial" }, // ✅ add serial header
                                            ...IndividualExcelHeaders,
                                        ]}
                                        btnName="Download Excel"
                                        fileName="Individual.xlsx" />
                                </div>

                                <div className="">
                                    <DownloadExcelButton
                                        // headers={IndividualExcelHeaders}
                                        headers={[
                                            { label: "S.No", key: "serial" }, // Add Serial Number column
                                            ...IndividualExcelHeaders
                                        ]}
                                        btnName="Download All Data"
                                        fileName="AllIndividual.xlsx"
                                        // onClick={async () => {
                                        //     const response = await getAllDataIndividaulList();
                                        //     const allData = response?.data?.data || [];
                                        //     return allData; // will be exported automatically inside the button
                                        // }}
                                        onClick={async () => {
                                            const response = await getAllDataIndividaulList();
                                            const csvData = response?.data;;
                                            const blob = new Blob([csvData], {
                                            type: "text/csv;charset=utf-8;",
                                            });

                                            const url = window.URL.createObjectURL(blob);
                                            const link = document.createElement("a");

                                            link.href = url;
                                            link.download = "AllIndividual.csv";

                                            document.body.appendChild(link);
                                            link.click();
                                            link.remove();

                                            window.URL.revokeObjectURL(url);

                                            return [];
                                        }}

                                    />

                                </div>
                                <div className="mx-1">
                                    <Button
                                        variant="primary"
                                        className=""
                                        onClick={() => setShowImportModal(true)}
                                    >
                                        Import Excel <i className="fa fa-plus"></i>
                                    </Button>
                                </div>

                                <div>
                                    <RefreshButton refreshCallback={handleRefresh} />


                                </div>
                            </div>



                        </div>
                        {/* Filters hidden for Super Admin; for Admin Checker, only All Status is hidden */}
                        {!isSuperAdmin && (
                            <>
                                <div className="d-flex px-3">
                                    {!isAdminChecker && (
                                        <div className="mx-2">
                                            <Form.Select
                                                value={selectedStatus}
                                                onChange={handleStatusChange}
                                                className="me-2"
                                                style={{ width: '100%', padding: '11px' }}
                                            >
                                                <option value="0">All Status</option>
                                                <option value="reject">Reject</option>
                                                <option value="pass">Pass</option>
                                                <option value="final_submit">Final Submit</option>
                                                <option value="ongoing">ongoing</option>
                                                <option value="ask_for_resubmit">Ask for Resubmit</option>
                                                <option value="pass_by_dso">Pass by DSO</option>
                                                <option value="pass_by_admin_checker">Pass by Admin Checker</option>
                                            </Form.Select>
                                        </div>
                                    )}
                                    <div className="mx-2">
                                        <DistrictFilter />
                                    </div>
                                    <div className="mx-2">
                                        <SportFilter />
                                    </div>
                                    <div className="">
                                        <CategorySubCategoryFilter typeId="1"
                                            selectedCategory={selectedCategory}
                                            setSelectedCategory={setSelectedCategory}
                                            selectedSubCategory={selectedSubCategory}
                                            setSelectedSubCategory={setSelectedSubCategory}
                                            placeholderText="Individual"
                                        />
                                    </div>
                                </div>
                                <div className="mx-4 d-flex">
                                    <div>
                                        <InsitutionCategoryFilter typeId="2"
                                            orgselectedCategory={orgselectedCategory}
                                            setOrgSelectedCategory={setOrgSelectedCategory}
                                            selectedInsitutionCategory={selectedInsitutionCategory}
                                            setSelectedInsitutionCategory={setSelectedInsitutionCategory}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </div>
                                    <div>
                                        <GenderFilter setCurrentPage={setCurrentPage}/>
                                    </div>
                                </div>
                            </>
                        )}


                    </div>

                    <div className="card-body">
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                                <form>
                                    <table id="example" className="display w-100 dataTable">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Prov.Reg.Id</th>
                                                <th>Applicant Full Name</th>
                                                <th>Email Id</th>
                                                <th>Organization Type</th>
                                                <th>Organization Name</th>
                                                {/* <th>Contact Number</th> */}
                                                <th>Date of Submission</th>
                                                <th>Attempt</th>
                                                <th>Remarks</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="11" className="text-center">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : individualDataList?.length > 0 ? (
                                                individualDataList.map((data, index) => {
                                                    const isQueueEnforced = isSuperAdmin || isAdminChecker;
                                                    const isAlreadyDone = isApplicationProcessedForRole(data?.status, user) || data?.status === "pass";
                                                    const isLockedByQueue = isQueueEnforced && firstPendingIndex !== -1 && index > firstPendingIndex;
                                                    const isActionDisabled = isQueueEnforced ? (isAlreadyDone || isLockedByQueue) : false;

                                                    return (
                                                        <tr key={data?.id || index}>
                                                            <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                                            <td>{data?.provisinal_registration_id}</td>
                                                            <td>{data?.name}</td>
                                                            <td>{data?.email}</td>
                                                            <td>{data?.orgnization_type}</td>
                                                            <td>{data?.orgnization_name}</td>
                                                            {/* <td>{data?.mobile}</td> */}
                                                            <td>{formatDateTime(data?.submitted_at || data?.date_of_submission || data?.created_at)}</td>
                                                            <td>{data?.attempt_count + 1}</td>
                                                            <td>{data?.remarks || data?.remark || "-"}</td>
                                                            <td style={{ color: getStatusColor(data?.status) }}>
                                                                {data?.status && formatStatus(data?.status)}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <div>
                                                                        <Button
                                                                            variant="danger"
                                                                            style={{ whiteSpace: 'nowrap' }}
                                                                            onClick={() => handleDeleteClick(data?.id)}
                                                                            disabled={isQueueEnforced ? (data?.status === "pass" || isActionDisabled) : false}
                                                                            title={isQueueEnforced && isLockedByQueue ? "Please complete the previous application first" : undefined}
                                                                        >
                                                                            Delete
                                                                        </Button>
                                                                    </div>
                                                                    <div className="mx-2">
                                                                        <Button
                                                                            style={{ whiteSpace: 'nowrap' }}
                                                                            onClick={() => handleVerificationClick(data?.id)}
                                                                            disabled={isQueueEnforced ? (data?.status === "pass" || isActionDisabled) : false}
                                                                            title={isQueueEnforced && isLockedByQueue ? "Please complete the previous application first" : undefined}
                                                                        >
                                                                            Verify Application
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="11" className="text-center">Data is not available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
                <ImportExcelModal
                    showImportModal={showImportModal}
                    setShowImportModal={setShowImportModal}
                    adminCategoryTypeData={adminCategoryTypeData}
                    getOrganisationListApi={getOrganisationListApi}
                    currentPage={currentPage}
                    perPage={perPage}
                    selectedStatus={selectedStatus}
                    setCurrentPage={setCurrentPage}
                    selectedSportsId={selectedSportId}
                    insitutionType="Individual"
                    typeValue="1"
                    selectedInsitutionCategoryId={selectedInsitutionCategoryId}
                    orgselectedCategory={orgselectedCategory}
                    selectedGender={selectedGender}

                />
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={2}
                    pageCount={Math.ceil(organisationdataList?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item mx-1 my-1"
                    pageLinkClassName="page-link"
                    previousClassName="page-item mx-1 my-1"
                    previousLinkClassName="page-link"
                    nextClassName="page-item mx-1 my-1"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item mx-1 my-1"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap "
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />

            </div>
        </>
    );
};

export default IndividualList;

